import Vue from 'vue';

Vue.prototype.$language = document.documentElement.lang.substr(0, 2);

const currentDate = new Date(),
    currentDay = currentDate.getDate(),
    currentMonth = currentDate.getMonth() + 1,
    currentYear = currentDate.getFullYear();

Vue.prototype.$datePickerOptions = {
    minDate:
        currentYear +
        '-' +
        (currentMonth > 9 ? '' : '0') +
        currentMonth +
        '-' +
        (currentDay > 9 ? '' : '0') +
        currentDay,
    format: 'DD.MM.YYYY',
    locale: Vue.prototype.$language,
    useCurrent: false,
};

Vue.mixin({
    methods: {
        checkLicensePlate: async function (plate, country) {
            return new Promise(function (resolve) {
                fetch(
                    '/' +
                        window.Vue.prototype.$language +
                        '/backend/validate/license-plate/' +
                        encodeURIComponent(plate) +
                        '/' +
                        country
                )
                    .then((result) => result.json())
                    .then((result) => {
                        resolve(result.isValid);
                    });
            });
        },
    },
});
